var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IxMap',{ref:"map",attrs:{"layers":[_vm.satLayer],"extent":_vm.extent,"after-extent-changed":'zoom'}})}
var staticRenderFns = []

export { render, staticRenderFns }